import React, { useState, useEffect } from 'react';
import navbarIcon from '../assets/images/navbaricon.png';

export default function Header({ currentRoute, navigate, onAuthClick, user, onSignOut, onInquiryClick }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const ENABLE_AUTH = false; // Set to true to re-enable authentication lock & login/signup buttons

  // Close mobile navigation when the route changes
  useEffect(() => {
    setMobileOpen(false);
  }, [currentRoute]);

  const navItems = [
    { key: '', label: 'Home' },
    { key: 'training', label: 'Corporate Training' },
    { key: 'functions', label: 'Functions' },
    { key: 'shortcuts', label: 'Shortcuts' },
    { key: 'skill-test', label: 'Test Your Skill' },
    { key: 'contact', label: 'Contact' }
  ];

  return (
    <>
      <div className="announcement-bar">
        <div className="container announcement-inner">
          Corporate Excel Training Available Across Sri Lanka — Onsite & Online.{' '}
          <a href="#/contact" onClick={(e) => { e.preventDefault(); navigate('contact'); }}>
            Plan Your Training →
          </a>
        </div>
      </div>
      <header className="site-header">
        <div className="container header-inner">
          <a
            className="brand"
            href="#/"
            onClick={(e) => {
              e.preventDefault();
              navigate('');
            }}
          >
            <span className="brand-mark brand-mark--full-logo">
              <img src={navbarIcon} alt="Mr Excel Sri Lanka" />
            </span>
          </a>
          <button
            className="menu-toggle"
            type="button"
            aria-label="Open navigation"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            ☰
          </button>
          <nav className={`site-nav ${mobileOpen ? 'open' : ''}`}>
            {navItems.map((item) => {
              const isTraining = item.key === '';
              const isVerifiedUser = user && (user.emailVerified || user.email === 'admin@mrexcelsrilanka.com');
              const isDisabled = ENABLE_AUTH && (!isTraining && !isVerifiedUser);
              const isActive = currentRoute === item.key || (item.key === '' && currentRoute === 'home');
              return (
                <a
                  key={item.key}
                  className={`${isActive ? 'active' : ''} ${isDisabled ? 'nav-disabled' : ''}`}
                  href={isDisabled ? '#/login' : `#/${item.key}`}
                  onClick={(e) => {
                    e.preventDefault();
                    if (isDisabled) {
                      onAuthClick('login');
                    } else {
                      navigate(item.key);
                    }
                  }}
                  style={isDisabled ? { display: 'inline-flex', alignItems: 'center', gap: '5px' } : undefined}
                >
                  {item.label}
                  {isDisabled && (
                    <span className="nav-lock-icon" style={{ fontSize: '0.72rem', opacity: 0.6 }}>🔒</span>
                  )}
                </a>
              );
            })}
            <a
              className="nav-cta"
              href="#/"
              onClick={(e) => {
                e.preventDefault();
                if (onInquiryClick) {
                  onInquiryClick();
                } else {
                  navigate('');
                }
              }}
            >
              Request Training
            </a>
            {ENABLE_AUTH && (
              user && (user.emailVerified || user.email === 'admin@mrexcelsrilanka.com') ? (
                <div className="user-profile-menu" style={{ display: 'flex', alignItems: 'center', gap: '15px', marginLeft: '12px' }}>
                  <span className="user-welcome" style={{ color: 'var(--green-dark)', fontSize: '0.82rem', fontWeight: '800' }}>
                    Hi, {user.displayName || user.email.split('@')[0]}
                  </span>
                  <button
                    className="nav-logout"
                    onClick={onSignOut}
                    style={{
                      background: 'transparent',
                      border: '1.5px solid #d22d2d',
                      borderRadius: '8px',
                      color: '#d22d2d',
                      padding: '8px 14px',
                      fontSize: '0.79rem',
                      fontWeight: '750',
                      cursor: 'pointer',
                      transition: 'all 0.18s ease'
                    }}
                    onMouseOver={(e) => { e.target.style.background = '#d22d2d'; e.target.style.color = '#fff'; }}
                    onMouseOut={(e) => { e.target.style.background = 'transparent'; e.target.style.color = '#d22d2d'; }}
                  >
                    Sign Out
                  </button>
                </div>
              ) : (
                <>
                  <a
                    className="nav-login"
                    href="#/login"
                    onClick={(e) => {
                      e.preventDefault();
                      onAuthClick('login');
                    }}
                  >
                    Log In
                  </a>
                  <a
                    className="nav-signup"
                    href="#/signup"
                    onClick={(e) => {
                      e.preventDefault();
                      onAuthClick('signup');
                    }}
                  >
                    Sign Up
                  </a>
                </>
              )
            )}
          </nav>
        </div>
      </header>
    </>
  );
}
